export default __webpack_public_path__ + "static/media/sustainability.inline.fd04aee3.svg";